module.exports = __webpack_public_path__ + "static/super_thankyou-d1b24367d28bb1c32e394c2e3f904d97.svg";